import { render, staticRenderFns } from "./AddBon.vue?vue&type=template&id=3f853a65&"
import script from "./AddBon.vue?vue&type=script&lang=js&"
export * from "./AddBon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports